import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { mediaApi } from '@sitecore-jss/sitecore-jss';
import { LazyImageFull, ImageState } from 'react-lazy-images';
import Skeleton from 'react-loading-skeleton';
import blank from '../../images/blank.png'; // IE Polyfill

import 'intersection-observer';

var ImageLazy = function ImageLazy(props) {
  var _media$value;

  var _props$media = props.media,
      media = _props$media === void 0 ? {} : _props$media,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      _props$loadEagerly = props.loadEagerly,
      loadEagerly = _props$loadEagerly === void 0 ? null : _props$loadEagerly,
      _props$type = props.type,
      type = _props$type === void 0 ? {} : _props$type,
      _props$myRef = props.myRef,
      myRef = _props$myRef === void 0 ? {} : _props$myRef;
  var resolvedSrc = '';
  var image = '';
  image = media === null || media === void 0 ? void 0 : (_media$value = media.value) === null || _media$value === void 0 ? void 0 : _media$value.src;
  resolvedSrc = image && image.match('olo-image') ? image : mediaApi.updateImageUrl(image, {});
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LazyImageFull, {
    src: resolvedSrc,
    debounceDurationMs: 50,
    debugActions: false,
    loadEagerly: loadEagerly
  }, function (_ref) {
    var _media$value2, _media$value3;

    var imageProps = _ref.imageProps,
        imageState = _ref.imageState,
        ref = _ref.ref;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("img", _extends({
      lazyloaded: imageState,
      className: "\n            cb-image\n            ".concat(className, "\n            "),
      height: media === null || media === void 0 ? void 0 : (_media$value2 = media.value) === null || _media$value2 === void 0 ? void 0 : _media$value2.height,
      width: media === null || media === void 0 ? void 0 : (_media$value3 = media.value) === null || _media$value3 === void 0 ? void 0 : _media$value3.width
    }, imageProps, {
      ref: ref,
      src: imageState === ImageState.LoadSuccess ? resolvedSrc : blank,
      style: {
        opacity: imageState === ImageState.LoadSuccess ? "1" : "0"
      }
    })), type === 'video' && /*#__PURE__*/React.createElement(Skeleton, {
      className: type + ' cb-skeleton cb-videoimage',
      height: myRef.current && myRef.current.parentElement.offsetHeight,
      width: myRef.current && myRef.current.parentElement.offsetWidth,
      style: {
        opacity: imageState === ImageState.LoadSuccess ? "0" : "1",
        left: myRef.current && myRef.current.parentElement.offsetLeft
      }
    }), type === 'product' && /*#__PURE__*/React.createElement(Skeleton, {
      className: type + ' cb-skeleton ',
      height: myRef.current && myRef.current.parentElement.offsetHeight > 0 ? myRef.current.parentElement.offsetHeight : 0,
      width: myRef.current && myRef.current.parentElement.offsetWidth,
      style: {
        left: 0,
        opacity: imageState === ImageState.LoadSuccess ? "0" : "1"
      }
    }), type === 'card' && /*#__PURE__*/React.createElement(Skeleton, {
      className: type + ' cb-skeleton',
      height: myRef.current && myRef.current.nextElementSibling.offsetHeight,
      width: myRef.current && myRef.current.nextElementSibling.offsetWidth,
      style: {
        left: 0,
        opacity: imageState === ImageState.LoadSuccess ? "0" : "1"
      }
    }));
  }));
};

export default ImageLazy;